// import React, { useState } from "react";
// import { useAuth } from "../context/AuthContext";
// import { useNavigate } from "react-router-dom";

// function formatPhoneNumber(value) {
//     // Убираем всё, кроме цифр
//     let digits = value.replace(/\D/g, "");
//     // Всегда начинаем с 7 (если пользователь попытается ввести 8, заменяем)
//     if (digits.length > 0 && digits[0] !== "7") digits = "7" + digits.slice(1);
//     // Ограничиваем 11 цифр (российский номер)
//     digits = digits.slice(0, 11);
//     let formatted = "+7";
//     if (digits.length > 1) formatted += " (" + digits.slice(1, 4);
//     if (digits.length >= 4) formatted += ") " + digits.slice(4, 7);
//     if (digits.length >= 7) formatted += "-" + digits.slice(7, 9);
//     if (digits.length >= 9) formatted += "-" + digits.slice(9, 11);
//     return formatted;
// }

// function getRawPhoneNumber(formatted) {
//     return formatted.replace(/[^\d+]/g, "");
// }

// export default function LoginScreen() {
//     // Инициализируем телефон с +7
//     const [phone, setPhone] = useState("+7");
//     const [password, setPassword] = useState("");
//     const { signIn } = useAuth();
//     const navigate = useNavigate();

//     const handleLogin = async () => {
//         const rawPhone = getRawPhoneNumber(phone);
//         if (!rawPhone || rawPhone.length < 12) {
//             // +7 и 10 цифр = 12 символов
//             alert("Введите корректный номер телефона");
//             return;
//         }
//         if (!password) {
//             alert("Введите пароль");
//             return;
//         }
//         const result = await signIn(rawPhone, password);
//         if (result.success) {
//             navigate("/orders");
//         } else {
//             alert(result.error);
//         }
//     };

//     return (
//         <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
//             <div className="w-full max-w-sm">
//                 <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">Вход</h1>

//                 <div className="mb-4">
//                     <label className="text-gray-700 mb-1 ml-1 block">Телефон</label>
//                     <input
//                         className="bg-white p-4 rounded-xl border border-gray-200 w-full text-base"
//                         placeholder="+7 (999) 999-99-99"
//                         value={phone}
//                         onChange={(e) => setPhone(formatPhoneNumber(e.target.value))}
//                         type="tel"
//                     />
//                 </div>

//                 <div className="mb-6">
//                     <label className="text-gray-700 mb-1 ml-1 block">Пароль</label>
//                     <input
//                         className="bg-white p-4 rounded-xl border border-gray-200 w-full text-base"
//                         placeholder="Введите пароль"
//                         type="password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                     />
//                 </div>

//                 <button onClick={handleLogin} className="w-full bg-blue-500 py-4 rounded-xl text-white font-bold text-lg">
//                     Войти
//                 </button>

//                 <button className="w-full mt-4 text-gray-500">Восстановить пароль</button>
//             </div>
//         </div>
//     );
// }

import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function formatPhoneNumber(value) {
    // Убираем всё, кроме цифр
    let digits = value.replace(/\D/g, "");
    // Всегда начинаем с 7 (если пользователь попытается ввести 8, заменяем)
    if (digits.length > 0 && digits[0] !== "7") digits = "7" + digits.slice(1);
    // Ограничиваем 11 цифр (российский номер)
    digits = digits.slice(0, 11);
    let formatted = "+7";
    if (digits.length > 1) formatted += " (" + digits.slice(1, 4);
    if (digits.length >= 4) formatted += ") " + digits.slice(4, 7);
    if (digits.length >= 7) formatted += "-" + digits.slice(7, 9);
    if (digits.length >= 9) formatted += "-" + digits.slice(9, 11);
    return formatted;
}

function getRawPhoneNumber(formatted) {
    return formatted.replace(/[^\d+]/g, "");
}

export default function LoginScreen() {
    // Инициализируем телефон с +7
    const [phone, setPhone] = useState("+7");
    const [password, setPassword] = useState("");
    const { signIn } = useAuth();
    const navigate = useNavigate();

    const handleLogin = async () => {
        const rawPhone = getRawPhoneNumber(phone);
        if (!rawPhone || rawPhone.length < 12) {
            // +7 и 10 цифр = 12 символов
            alert("Введите корректный номер телефона");
            return;
        }
        if (!password) {
            alert("Введите пароль");
            return;
        }
        const result = await signIn(rawPhone, password);
        if (result.success) {
            navigate("/orders");
        } else {
            alert(result.error);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
            <div className="w-full max-w-sm">
                <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">Вход</h1>

                <div className="mb-4">
                    <label className="text-gray-700 mb-1 ml-1 block">Телефон</label>
                    <input
                        className="bg-white p-4 rounded-xl border border-gray-200 w-full text-base"
                        placeholder="+7 (999) 999-99-99"
                        value={phone}
                        onChange={(e) => setPhone(formatPhoneNumber(e.target.value))}
                        type="tel"
                    />
                </div>

                <div className="mb-6">
                    <label className="text-gray-700 mb-1 ml-1 block">Пароль</label>
                    <input
                        className="bg-white p-4 rounded-xl border border-gray-200 w-full text-base"
                        placeholder="Введите пароль"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>

                <button onClick={handleLogin} className="w-full bg-blue-500 py-4 rounded-xl text-white font-bold text-lg">
                    Войти
                </button>

                {/* Вот эта кнопка теперь работает */}
                <button onClick={() => navigate("/forgot-password")} className="w-full mt-4 text-gray-500">
                    Восстановить пароль
                </button>
            </div>
        </div>
    );
}
